// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"GJ-z","smallCardRow":"HJ-z","largeCardRow":"IJ-z","productSearchRow":"JJ-z","curatedRow":"KJ-z"};